<template>
  <canvas
    :id="chartData.id"
  />
</template>
<script>
import Chart from 'chart.js/auto'
export default {
  name: 'BaseDoughnutChartV2',
  props: {
    chartData: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      chart: null
    }
  },
  computed: {
    options () {
      return {
        hover: {mode: null},
        maintainAspectRatio: false,
        cutout: 50,
        responsive: false,
        plugins: {
          tooltip: this.tooltipOptions,
          legend: {
            display: false
          },
          datalabels: {
            display: false
          }
        }
      }
    },
    tooltipOptions () {
      return {
        position: 'nearest',
        callbacks: {
          title: (context) => {
            return context[0].label
          },
          label: (context) => {
            return context.dataset.legendTooltip ? context.dataset.legendTooltip.title + ' : ' + context.dataset.legendTooltip.value[context.dataIndex] + ' ' + context.dataset.legendTooltip.unit : null
          }
        },
      }
    }
  },
  watch: {
    chartData: {
      handler () {
        this.chart.data = this.chartData
        this.chart.update()
      }
    },
    options: {
      handler () {
        this.chart.options = this.options
        this.chart.update()
      }
    }
  },
  mounted () {
    this.render()
  },

  methods: {
    render () {
      const doughnutChartHtmlElement = document.getElementById(this.chartData.id)
      const config = {
        type: 'doughnut',
        data: this.chartData,
        options: this.options
      }
      this.chart = new Chart(doughnutChartHtmlElement, config)
    }
  }
}
</script>

<style lang="scss" scoped>
canvas {
  width: 160px !important;
  height: 160px !important;
}
</style>
